import React, {
  useEffect,
  useLayoutEffect,
  useRef,
} from 'react'
import {
  Container,
  OptionBtn,
  SelectedBg
} from './styles'

const ButtonSelector = ({ selected, options, onChange }) => {

  const ref = useRef();
  const selectedBgRef = useRef()
  
  const handleBg = () => {
    const { active } = ref.current.children
    selectedBgRef.current.style.left = `${active.offsetLeft}px`
    selectedBgRef.current.style.width = `${active.offsetWidth}px`
    selectedBgRef.current.style.height = `${active.offsetHeight}px`
  }

  useLayoutEffect(() => {
    handleBg()
  }, [selected])

  useEffect(() => {
    window.addEventListener('resize', handleBg)
    return () => window.removeEventListener('resize', handleBg)
  }, [])

  return (
    <Container >
      <div ref={ref}>
        {options.map(opt => (
          <OptionBtn
            key={opt.label}
            id={opt.offset === selected.offset ? 'active' : ''}
            $isActive={opt.offset === selected.offset}
            onClick={() => onChange(opt)}
          >
            {opt.label}
          </OptionBtn>
        ))}
        <SelectedBg ref={selectedBgRef}/>
      </div>
    </Container>
  )
}

export default ButtonSelector